/* eslint-disable array-callback-return */
export const getContainerClassInfo = (role:string) => {
    switch(role) {
      case 'admin': case 'leader':
        return 'containerInfoAdmin';
      case 'collaborator':
        return 'containerInfoUser';    
    }
  };
export const getContainerClassQualification = (role:string) => {
    switch(role) {
      case 'admin': case 'leader':
        return 'containerGraphsAdmin';
      case 'collaborator':
        return 'containerGraphsUser';    
    }
  }
export const getContainerTypeEval = (typeEval:number) => {
    switch(typeEval) {
      case  1:  case  2: case  3: case  4:
        return 'containerTypeEval';        
    }
  };
export const getContainerTypeEvalResults = (typeEval:number) => {
    switch(typeEval) {
      case  1: 
        return 'containerTypeEval90Results';
      case  2: 
        return 'containerTypeEval180Results';
      case  3: 
        return 'containerTypeEval270Results';
      case  4: 
        return 'containerTypeEval360Results';
    }
  }; 

const typeMapping: Record<string, string> = {
    'autoevaluacion': 'Autoevaluación',
    'lider': 'Líder',
    'colega': 'Colega',
    'subordinado': 'Subordinado',
    'cliente': 'Cliente'
  };
  
export const changeType = (typeEval: string): string => {
    return typeMapping[typeEval] || 'Tipo no reconocido';
  };

export const infoCalif = (data:any) => 
  data.map((competence: { infoEvalByCompetence: any[]; nameCompetence: any; }) => {
      const firstEvaluation = competence.infoEvalByCompetence[0];
      return {
          nameCompetence: competence.nameCompetence,
          CalificationByCompetence: firstEvaluation.CalificationByCompetence,
          desviacionByCompetence: firstEvaluation.desviacionByCompetence,
          minReq: firstEvaluation.minReq
      };
  });

 export const convertDesviacionToString=(inputValue:any)=>{
  let result;

  if (inputValue >= 0 && inputValue <= 0.9) {
      result = 'nulo';
  } else if (inputValue >= 1 && inputValue <= 1.99) {
      result = 'deficiente';
  } else if (inputValue >= 2 && inputValue <= 2.99) {
      result = 'básico';
  } else if (inputValue >= 3 && inputValue <= 3.99) {
      result = 'intermedio';
  } else if (inputValue >= 4 && inputValue <= 4.99) {
      result = 'avanzado';
  } else if (inputValue >= 5) {
      result = 'sobresaliente';
  } else {
      result = 'fuera de rango';
  }
  return result.toUpperCase();
 }

 const converTxtToNumber = (value: string): number => {
  const mapping: { [key: string]: number } = {
    'nulo': 0,
    'deficiente': 1,
    'básico': 2,
    'intermedio': 3,
    'avanzado': 4,
    'sobresaliente': 5
  };
  return mapping[value] !== undefined ? mapping[value] : NaN; 
};

export const convertCalifTxt = (minReq: string, obtain: string): string => {
  const minReqNum = converTxtToNumber(minReq.toLowerCase());
  const obtainNum = converTxtToNumber(obtain.toLowerCase());
  return obtainNum >= minReqNum ? 'strength' : 'debility';
};

export const calcularCumplimiento =( competencias:any )=> {
  
  const competenciasCumplen = competencias.filter((comp: { CalificationByCompetence: number; minReq: number; }) => comp.CalificationByCompetence >= comp.minReq);
  const conteoCumple = competenciasCumplen.length;
  const numeroCompetencias = competencias.length; 
  return conteoCumple / numeroCompetencias;
};

export const minEsperadoTotal =( competencias:any ):any=> {
  const maxCalif = 5;
  const sumMinReq = competencias.reduce((sum: any, item: { minReq: any; }) => sum + item.minReq, 0);
  const numeroCompetencias = competencias.length;
  const totalMaxCalif = numeroCompetencias * maxCalif;  
  const porcentaje = totalMaxCalif === 0 ? 0 : (sumMinReq / totalMaxCalif) * 100;
  return porcentaje.toFixed(2);
};
  
export const getBarData = (data: any) => {
  const dataBar= data?.map((item: any) => {
      const result = ((item.sum * 100 )/ (item.count *5)).toFixed(2)
      const name2 = changeType(item.typeEval);
      return {
        name: name2,
        value: result
      };
  });
  return dataBar
}

export const getSpiderConfig = (data: any) => {
  const configSpider = data?.map((item: any) => {
     const CompetenciaName = item.nameCompetence
      return {
        name: CompetenciaName,
        maxValue: 100
      };
  });
  return configSpider
}

export const getSpiderData = (data: any) => {
  let contianerObj = []
  let objAuto: {[k: string]: any} = {    
  }
  //  let objMinima: {[k: string]: any} = {
  //   name:'minima',
  //   color:'#d83a51'
  //  }
   let objObtenida: {[k: string]: any} = {
    name:'obtenida',
    color:'#4aadff'
   }

  data?.map((item: any) => {
    const nameCom = item.nameCompetence
    const evaluatedResults=  item?.infoEvalByCompetence?.map((item: any) => ({
      ...item,
      resultCompetenceIndividual: calculateEvaluationSpider(item)
    }));
  
    const autoevaluacion = evaluatedResults.find((item: { typeEval: string; }) => item.typeEval === 'autoevaluacion');
    const autoEvaluacionValue = autoevaluacion !== undefined ? parseFloat(autoevaluacion.resultCompetenceIndividual.toFixed(3)).toFixed(2) : '0'

    const res=computeSumAndCount(evaluatedResults)

    // const minima = ((evaluationsWithTotal[0].minReq/5)*100).toFixed(2)

    const obtenida = ((res.sum)/res.count) > 100 ? 100:((res.sum)/res.count)
    //Añadimos valor de la competencia de auto
    objAuto[nameCom] = parseFloat(autoEvaluacionValue)
    //Añadimos valorMinimo  de la
    // objMinima[nameCom] = parseFloat(minima)
    //Añadimos valor obtenido / valor de la evaluación
    objObtenida[nameCom]= obtenida

  })

  //verificamos si el minimo tieen todo en cero
  if(allPropertiesAreZero(objAuto)){
    contianerObj.push(objObtenida)
    // contianerObj.push(objMinima)
    return contianerObj
  }
  //despues pasamos color y nombre y lo metemos si no
  objAuto['name'] = 'autoevaluacion'
  objAuto['color'] ='#ffd152'
  //Añadimos al contenedor y retornamos
  contianerObj.push(objAuto)
  contianerObj.push(objObtenida)
  // contianerObj.push(objMinima)
  return contianerObj
}

const calculateEvaluationSpider = (evaluation: any): number => {
  if (evaluation.result >= evaluation.minReq) {
    return 100;
  } else {
    return Number(((evaluation.result / evaluation.minReq) * 100));
  }
};

const computeSumAndCount = (data: Array<{ [key: string]: any }>): { sum: number, count: number } => {
  const filteredData = data.filter(item => {
    switch (item.typeEval) {
      case 'autoevaluacion':
        return Number(item.pesoAuto) > 0;
      case 'lider':
        return Number(item.pesoLider) > 0;
      case 'colega':
        return Number(item.pesoColega) > 0;
      case 'subordinado':
        return Number(item.pesoSubordinado) > 0;
      case 'cliente':
        return Number(item.pesoCliente) > 0;
      default:
        return false;
    }
  });
  const sum = filteredData.reduce((total, item) => total + item.resultCompetenceIndividual, 0);
  const count = filteredData.length;
  return { sum, count };
};

function allPropertiesAreZero(obj: { [x: string]: number; }) {
  return Object.keys(obj).every(key => obj[key] === 0);
}


export const containerResulInfo=(value:string) =>{
  const changeMinValue= value.toLowerCase()
  switch(changeMinValue) {
    case  'nulo': 
      return 'containerResulInfoInter';
    case  'deficiente': 
    return 'containerResulInfoDef';
    case  'básico': 
    return 'containerResulInfoBas';
    case  'intermedio': 
    return 'containerResulInfoInter';
    case   'avanzado': 
    return 'containerResulInfoAvan';
    case   'sobresaliente': 
    return 'containerResulInfoSob';
  }
}

export const containerResultInfoGraf=(value:string) =>{
  const changeMinValue= value.toLowerCase()
  if(changeMinValue==='sobresaliente'){
    return 'containerEvalResGraphSob'
  }
  else{
    return 'containerEvalResGraph'
  }
}